import { render, staticRenderFns } from "./ReportScoreAccAha.vue?vue&type=template&id=12ad52e5"
import script from "./ReportScoreAccAha.vue?vue&type=script&lang=js"
export * from "./ReportScoreAccAha.vue?vue&type=script&lang=js"
import style0 from "./ReportScoreAccAha.vue?vue&type=style&index=0&id=12ad52e5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports